import { getAlternateTemplate } from '../services/template.service';
class HotspotButton extends HTMLElement {
    trigger = null;
    closeBtn = null;
    productFetched = false;
    isFetching = false;
    connectedCallback() {
        this.trigger = this.querySelector('.split-layout__hotspot-trigger');
        this.closeBtn = this.querySelector('.split-layout__hotspot-popup-close');
        this.trigger?.addEventListener('click', this.handleTriggerClick);
        this.closeBtn?.addEventListener('click', this.handleCloseClick);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
    }
    disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.handleTriggerClick);
        this.closeBtn?.removeEventListener('click', this.handleCloseClick);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
    }
    handleTriggerClick = async (e) => {
        e.stopPropagation();
        if (this.isFetching)
            return;
        if (this.hasAttribute('open')) {
            this.close();
            return;
        }
        document.querySelectorAll('hotspot-button[open]').forEach(el => el.close());
        const handle = this.getAttribute('product-handle');
        if (handle && !this.productFetched) {
            await this.fetchAndRenderPopup(handle);
        }
        // Only open if there is a popup to show (Liquid-rendered or successfully fetched)
        if (this.querySelector('.split-layout__hotspot-popup')) {
            this.open();
        }
    };
    handleCloseClick = (e) => {
        e.stopPropagation();
        this.close();
    };
    handleDocumentClick = () => {
        if (this.hasAttribute('open')) {
            this.close();
        }
    };
    handleKeydown = (e) => {
        if (e.key === 'Escape' && this.hasAttribute('open')) {
            this.close();
        }
    };
    async fetchAndRenderPopup(handle) {
        this.isFetching = true;
        try {
            const html = await getAlternateTemplate(`/products/${handle}`, 'hotspot-popup-api');
            this.insertAdjacentHTML('beforeend', html);
            this.productFetched = true;
            // Wire up the close button that was just injected
            this.closeBtn = this.querySelector('.split-layout__hotspot-popup-close');
            this.closeBtn?.addEventListener('click', this.handleCloseClick);
        }
        catch {
            // Silently fail — no popup rendered, button press is a no-op
        }
        finally {
            this.isFetching = false;
        }
    }
    open() {
        this.setAttribute('open', '');
        this.trigger?.setAttribute('aria-expanded', 'true');
    }
    close() {
        this.removeAttribute('open');
        this.trigger?.setAttribute('aria-expanded', 'false');
    }
}
if (!window.customElements.get('hotspot-button')) {
    customElements.define('hotspot-button', HotspotButton);
}
